import * as React from "react";
import { Text, mergeStyleSets, getTheme } from "@fluentui/react";

export const getClassNames = (theme) => {
  return mergeStyleSets({
    container: {
      padding: theme.spacing.s1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: theme.palette.themePrimary,
    },
    main: {
      display: "flex",
      flexDirection: "column",
      alignSelf: "start",
      padding: theme.spacing.s1,
      paddingTop: theme.spacing.s2,
    },
    caseNumber: {
      fontSize: 16,
      fontWeight: 500,
      color: theme.palette.white,
      marginBottom: theme.spacing.s2,
    },
    caseDescription: {
      fontSize: 12,
      fontWeight: 400,
      color: theme.palette.white,
    },
  });
};

const Header = ({ logo, caseNum = null, caseDesc = null }) => {
  let theme = getTheme();
  let { container, main, caseNumber, caseDescription } = getClassNames(theme);
  return (
    <section className={container}>
      <img width="80" height="40" src={logo} alt="Logo" title="Logo" />
      <div className={main}>
        {caseNum && (
          <>
            <Text className={caseNumber}>Case #{caseNum}</Text>
            {caseDesc && (
              <>
                <Text className={caseNumber}>Case Description</Text>
                <Text className={caseDescription}>{caseDesc}</Text>
              </>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default Header;
